import { useEffect, useState } from 'react';
import { subscribe, type EmbedState } from '../embed/host-bridge';
import { applyTheme } from '../theme/applyTheme';

// Hook que expone el estado del puente con el host (token, bffUrl, company, theme, ready).
export function useEmbed(): EmbedState {
  const [state, setState] = useState<EmbedState>(() => ({
    token: null,
    bffUrl: '',
    company: null,
    locale: 'es-AR',
    ready: false,
  }));

  useEffect(() => {
    return subscribe((s) => {
      setState(s);
      applyTheme(s.theme);
    });
  }, []);

  return state;
}
